import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import { reduce, each } from 'lodash';
import { withRouter } from 'react-router-dom';
import { getPrograms, getProgramLoading, getProgramLoaded } from '../../../Nomination/NominationReducer';
import { fetchPrograms } from '../../../Nomination/NominationActions';
import ProgressBar from '../../../../components/progress-bar';
import MappingTable from './MappingTable';

class TruVoiceProductsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillMount() {
    this.props.dispatch(fetchPrograms());
  }

  renderContent() {
    const { programs } = this.props;
    return (
      <MappingTable programs={programs} />
    );
  }


  renderEmptyPrograms() {
    return (
      <div className="alert alert-warning">
        No TruVoice programs found.
      </div>
    );
  }

  render() {
    const {
      loading, loaded, programs,
    } = this.props;
    const isLoading = loading || !loaded;

    if (isLoading) {
      return (<div className="container"><ProgressBar /></div>);
    }

    const allPrograms = reduce(programs, (items, subPrograms) => {
      each(subPrograms, (subProgram) => {
        items.push(subProgram);
      });
      return items;
    }, []);
    const hasPrograms = allPrograms.length > 0;

    return (
      <div className="container">
        <Helmet title="TruVoice Program Products" />
        {!hasPrograms && this.renderEmptyPrograms()}
        {hasPrograms && this.renderContent()}
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps(state) {
  return {
    programs: getPrograms(state),
    loading: getProgramLoading(state),
    loaded: getProgramLoaded(state),
  };
}

TruVoiceProductsPage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  location: PropTypes.shape({
    search: PropTypes.string,
    pathname: PropTypes.string,
  }).isRequired,
  programs: PropTypes.shape({}).isRequired,
  loading: PropTypes.bool.isRequired,
  loaded: PropTypes.bool.isRequired,
};

TruVoiceProductsPage.contextTypes = {
  router: PropTypes.shape({}),
};

export default withRouter(connect(mapStateToProps)(TruVoiceProductsPage));
